import { render } from "./softwarecopyright-count.vue?vue&type=template&id=5ca37760&scoped=true"
import script from "./softwarecopyright-count.vue?vue&type=script&lang=js"
export * from "./softwarecopyright-count.vue?vue&type=script&lang=js"

import "./softwarecopyright-count.vue?vue&type=style&index=0&id=5ca37760&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca37760"]])

export default __exports__